import request from './request'

export function login(data) {
  return request({ url: '/admin/auth/login', method: 'post', data })
}

export function getMenus() {
  return request({ url: '/admin/auth/menus', method: 'get' })
}

export function getDashboard() {
  return request({ url: '/admin/auth/dashboard', method: 'get' })
}

export function logout() {
  return request({ url: '/admin/auth/logout', method: 'post' })
}

export function changePassword(data) {
  return request({ url: '/admin/auth/password', method: 'put', data })
}
